import { gql } from "@apollo/client";
import CommentFields from "~/lib/queries/fragments/CommentFields";

export default gql`
  query Comments($targetId: ObjectId!, $targetType: CommentTargetType!, $cursor: Cursor) {
    comments(targetId: $targetId, targetType: $targetType, cursor: $cursor, limit: 20) {
      items {
        _id
        ...CommentFieldsLegacy
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }

  ${CommentFields}
`;
